import { StrictMode } from 'react';
import { AppRoutes } from './routes';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { Error404 } from './components/page-errors/Error404'
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { UserProvider } from '../src/utils/auth'
import { ProSidebarProvider } from 'react-pro-sidebar';
const queryClient = new QueryClient();

export const App = () => {
  return (
    <StrictMode>
      <ErrorBoundary fallback={<Error404 />}>
        <Provider store={store}>
           <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <ProSidebarProvider>
                <UserProvider>
                <AppRoutes />
                </UserProvider>
               </ProSidebarProvider>
            </BrowserRouter>
          </QueryClientProvider>
        </Provider>
      </ErrorBoundary>
    </StrictMode>
  );
};